module.exports = __webpack_public_path__ + "img/award_2020.f0f57df1.png";